import { useState, CSSProperties } from "react";
import {
  ColorName,
  Colors,
  Text,
  Tooltip,
  TooltipFocusableTrigger,
} from "@zapier/design-system";

import { truncateUrl } from "../../utils/truncateUrl";
import { UnstyledButton } from "../UnstyledButton";
import { ExternalLink } from "../ExternalLink";
import { ExternalLinkWarning } from "../ExternalLinkWarning";

import styles from "./NodeLinkDisplay.module.css";

interface NodeLinkDisplayProps {
  link: string;
  isViewOnlyMode: boolean;
  onLinkClick: () => void;
  textColor?: ColorName | string;
  linkColor?: string;
  urlTruncateLength?: number;
}

export function NodeLinkDisplay({
  link,
  isViewOnlyMode,
  onLinkClick,
  textColor = "TextWeakest",
  linkColor = Colors.GrayWarm6,
  urlTruncateLength = 16,
}: NodeLinkDisplayProps) {
  const [showLinkConfirmation, setShowLinkConfirmation] = useState(false);
  const [showLinkBlocked, setShowLinkBlocked] = useState(false);

  const style: CSSProperties = {
    color: linkColor,
  };

  return (
    <div className={styles.wrapper}>
      <Tooltip
        content={link}
        placement="bottom left"
        allowMultiline
        offset={20}
        className={styles.tooltip}
      >
        <TooltipFocusableTrigger>
          <div className={styles.linkContainer}>
            <UnstyledButton onClick={onLinkClick} disabled={isViewOnlyMode}>
              <Text color={textColor as ColorName} type="MinimalPrint1">
                {truncateUrl(link, urlTruncateLength)}
              </Text>
            </UnstyledButton>
            <ExternalLink
              href={link}
              style={style}
              setShowLinkConfirmation={setShowLinkConfirmation}
              setShowLinkBlocked={setShowLinkBlocked}
            />
          </div>
        </TooltipFocusableTrigger>
      </Tooltip>
      {(showLinkConfirmation || showLinkBlocked) && (
        <ExternalLinkWarning
          href={link}
          showLinkConfirmation={showLinkConfirmation}
          setShowLinkConfirmation={setShowLinkConfirmation}
          showLinkBlocked={showLinkBlocked}
          setShowLinkBlocked={setShowLinkBlocked}
        />
      )}
    </div>
  );
}
